//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "PDA",
  data() {
    return {
      disabled: false,
      hasScore: false,
      form: {
        item1: '',
        item2: '',
        item3: '',
        item4: '',
        item5: '',
      },
      item1List: [
        { value: '0', name: '<160' },
        { value: '1', name: '160~180' },
        { value: '2', name: '>180' },
      ],
      item2List: [
        { value: '0', name: '无' },
        { value: '1', name: '收缩期' },
        { value: '2', name: '连续性' },
      ],
      item3List: [
        { value: '0', name: '正常' },
        { value: '1', name: '肱动脉搏动增强' },
        { value: '2', name: '肱和足背动脉搏动增强' },
      ],
      item4List: [
        { value: '0', name: '无' },
        { value: '1', name: '可触及' },
        { value: '2', name: '看到' },
      ],
      item5List: [
        { value: '0', name: '<0.6' },
        { value: '1', name: '0.6~0.65' },
        { value: '2', name: '>0.6' },
      ],
    }
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  created() {
    this.hideLoad();
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        let result = form.item1 + form.item2 + form.item3 + form.item4 + form.item5
        self.hasScore = true;
        return String(result);
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/PDA.vue